<template>
  <div>
    <Navbar />
    <div class="comapny-layout">
        <CompanySidebar :company="company"/>
        <div class="company-layout-content">
            <div class="company-heading">
                <h3>All Clients</h3>
                <input type="text" placeholder="Search Company">
                <button>Add new company</button>
            </div>
            <div class="companies">
                <div v-for="company in company" :key="company.id">
                  <router-link class="company" :to="{ path: '/admin/company/' + company.id}">
                    <img src="@/assets/company-icon.svg" alt="company-icon">
                    <p>{{ company.company_name }}</p>
                  </router-link>
                </div>
                <!-- <div class="company">
                    <img src="@/assets/company-icon.svg" alt="company-icon">
                    <p>Oilcom Ltd</p>
                </div> -->
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import Navbar from '@/components/NavBar.vue';
import CompanySidebar from '@/components/CompanySidebar.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'Company',
  components: {
    Navbar,
    CompanySidebar
  },
  async mounted() {
    await this.fetchCompany();
  },
  computed: {
    ...mapGetters(['getLoggedUser']),
    ...mapGetters('apps', {
      company: 'getCompany'
    })
  },
  methods: {
    ...mapActions('apps', [
      'fetchCompany'
    ])
  }
};
</script>

<style scoped lang="scss">
.comapny-layout {
    margin-top: 100px;
    display: grid;
    grid-template-columns: 0.5fr 2fr;
}
.company-layout-content {
    background: rgba(196, 196, 196, 0.1);
    padding: 30px 40px;
}
.company-heading {
    display: flex;
    justify-content: space-between;
    align-items: center;
    h3 {
        font-style: normal;
        font-weight: normal;
        font-size: 26px;
        line-height: 30px;
        letter-spacing: -0.4px;
        color: #000000;
    }
    button {
        background: #3887F6;
        border: 1px solid #3887F6;
        box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);font-style: normal;
        font-weight: normal;
        font-size: 16px;
        line-height: 18px;
        letter-spacing: -0.4px;
        color: #FFFFFF;
        padding: 16px 50px;
    }
}
.companies {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr;
    gap: 40px;
    margin-top: 50px;
    .company {
        background: #FFFFFF;
        border: 0.5px solid #C4C4C4;
        padding: 24px;
        display: flex;
        flex-direction: column;
        // max-width: 163.92px;;
        p {
            text-align: center;
            margin-top: 20px;
        }
    }
}
</style>
